export default __webpack_public_path__ + "static/media/vc6.8f58567f.jpg";